var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var ChartData = /** @class */ (function () {
    function ChartData() {
        this.assignedChart = {
            credits: {
                enabled: false
            },
            title: { text: null },
            animation: false,
            exporting: false,
            chart: {
                type: 'column',
                margin: 3,
                height: 32,
                width: 40,
            },
            tooltip: {
                backgroundColor: 'transparent',
                border: 0,
                borderWidth: 0,
                shadow: false,
                width: 500,
                formatter: function () {
                    return this.y;
                },
            },
            series: [{
                    data: [0, 20, 30, 0, 0, 0],
                    color: '#f57f17',
                    showInLegend: false
                }]
        };
        this.completedChart = {
            credits: {
                enabled: false
            },
            title: { text: null },
            animation: false,
            exporting: false,
            chart: {
                type: 'column',
                margin: 3,
                height: 32,
                width: 40,
            },
            backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
            },
            tooltip: {
                backgroundColor: 'transparent',
                border: 0,
                borderWidth: 0,
                shadow: false,
                width: 500,
                formatter: function () {
                    return this.y;
                },
            },
            series: [{
                    data: [],
                    color: '#388e3c',
                    showInLegend: false
                }]
        };
        this.ontimeChart = {
            credits: {
                enabled: false
            },
            title: { text: null },
            animation: false,
            exporting: false,
            chart: {
                type: 'column',
                margin: 3,
                height: 32,
                width: 40,
            },
            tooltip: {
                backgroundColor: 'transparent',
                border: 0,
                borderWidth: 0,
                shadow: false,
                width: 500,
                formatter: function () {
                    return this.y;
                },
            },
            series: [{
                    data: [0, 0, 0, 0, 0, 0, 0],
                    color: '#4caf50',
                    showInLegend: false
                }]
        };
        this.travelChart = {
            credits: {
                enabled: false
            },
            title: false,
            animation: false,
            exporting: false,
            chart: {
                type: 'column',
                margin: 3,
                height: 32,
                width: 40,
            },
            tooltip: {
                backgroundColor: 'transparent',
                border: 0,
                borderWidth: 0,
                shadow: false,
                width: 500,
                formatter: function () {
                    return this.y;
                },
            },
            series: [{
                    data: [0, 0, 0, 0, 0, 0, 0],
                    color: '#1E698E',
                    showInLegend: false
                }]
        };
        this.fuelChart = {
            credits: {
                enabled: false
            },
            title: { text: null },
            animation: false,
            exporting: false,
            chart: {
                type: 'column',
                margin: 3,
                height: 32,
                width: 40,
            },
            tooltip: {
                backgroundColor: 'transparent',
                border: 0,
                borderWidth: 0,
                shadow: false,
                width: 500,
                formatter: function () {
                    return this.y;
                },
            },
            series: [{
                    data: [0, 0, 0, 0, 0, 0, 0],
                    color: '#4e342e',
                    showInLegend: false
                }]
        };
        this.carbonChart = {
            credits: {
                enabled: false
            },
            title: { text: null },
            animation: false,
            exporting: false,
            chart: {
                type: 'column',
                margin: 3,
                height: 32,
                width: 40,
            },
            tooltip: {
                backgroundColor: 'transparent',
                border: 0,
                borderWidth: 0,
                shadow: false,
                width: 500,
                formatter: function () {
                    return this.y;
                },
            },
            series: [{
                    data: [0, 0, 0, 0, 0, 0, 0],
                    color: '#424242',
                    showInLegend: false,
                }]
        };
    }
    ChartData = __decorate([
        Injectable()
    ], ChartData);
    return ChartData;
}());
export { ChartData };



//////////////////
// WEBPACK FOOTER
// ./src/app/tasks/chart-data.ts
// module id = ./src/app/tasks/chart-data.ts
// module chunks = main